import i18n from "@src/utils/i18n";
const { t } = i18n;
import toast from "react-hot-toast";

// PARSING ERROR MESSAGE FROM API RESPONSE
// AND SHOW TOAST BY DEFAULT BASED ON showToast
export const parseError = (err, showToast = true) => {
  if (err?.response?.status == 401) return;

  if (err.message === "Network Error") {
    return "No internet connection";
  }

  // console.log(err, "*********error**parseError");
  try {
    if (showToast && window)
      toast?.error(
        err?.response?.data?.message ||
          t("utils.parseError.somethingWrongErrorText", "Something went wrong")
      );
  } catch (error) {}
  return (
    err?.response?.data?.message ||
    t("utils.parseError.somethingWrongErrorText", "Something went wrong")
  );
};

export default parseError;
